<template>
  <div class="container_caree">
    <div class="banner"></div>
    <div class="container">
      <Row class="list">
        <!-- <Col span="8"  v-for="(item,index) in careerData"  :class="index%2==0?'list-item':'list-item outStanding'" :key="item.id" :xs="24" :sm="8"> -->
        <Col span="8" v-for="(item,index) in careerData" class="list-item" :key="item.id" :xs="24" :sm="8">
        <div class="list-item-inner">
          <div class="list-item-top" :style="{background:'url('+item.imgsrc+') no-repeat',backgroundSize:'cover'}"></div>
          <!-- <div class="list-item-middle" :style="{background:'url('+item.imgsrc+') no-repeat',backgroundSize:'cover'}"></div> -->
          <div class="content">
            <div class="name">{{item.jobName}}</div>
            <div class="demand">{{item.demand}}</div>
          </div>
          <div class="list-item-bottom">
            <div @click="searchDetail(item.id)" class="highligthBtn">查看更多</div>
          </div>
        </div>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import frontImg from '../../assets/frontBg.png'
import designImg from '../../assets/UIBg.png'
import javaImg from '../../assets/backBg.png'
var careerSource = [{
  id: 1,
  imgsrc: frontImg,
  jobName: '前端工程师',
  demand: '全职/薪资面议/3年以上/本科及以上'
}, {
  id: 2,
  imgsrc: designImg,
  jobName: '高级UI设计师',
  demand: '全职/薪资面议/3年以上/本科及以上'
}, {
  id: 3,
  imgsrc: javaImg,
  jobName: '后端工程师',
  demand: '全职/薪资面议/3年以上/本科及以上'
}]
export default {
  name: "index",
  data() {
    return {
      careerData: careerSource
    }
  },
  methods: {
    searchDetail(id) {
      this.$router.push({ path: '/careerDetail', query: { id: id } })
    }
  }
};
</script>
<style scoped lang="less" src="./../../style/index.less"></style>
<style scoped lang="less" src="./index.less">
</style>



// WEBPACK FOOTER //
// src/page/Career/index.vue